module.exports = __webpack_public_path__ + "img/1440.fc8b2083.jpg";